const footerNav = [
  { href: "#synopsis", label: "作品简介" },
  { href: "#formats", label: "四种形式" },
  { href: "#library", label: "内容目录" },
  { href: "#characters", label: "人物小传" },
  { href: "#guide", label: "追更指南" },
  { href: "#updates", label: "目录动态" },
  { href: "#faq", label: "常见问题" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-accent-900 text-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-8">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_0.8fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 text-accent-900">
                <i className="ri-moon-foggy-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">善良的嫂子</span>
            </div>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-background-200">
              本站是一个围绕《善良的嫂子》作品的内容导航页，集中整理小说、短剧、漫画、视频四种形式的目录与介绍，
              方便读者与观众按需浏览、顺畅追更。
            </p>
            <a
              href="#top"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm font-medium text-accent-900 transition-colors hover:bg-background-100"
            >
              <i className="ri-arrow-up-line" />
              回到顶部
            </a>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">页面导航</h3>
            <nav className="mt-4 flex flex-wrap gap-x-5 gap-y-3">
              {footerNav.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="whitespace-nowrap text-sm text-background-200 transition-colors hover:text-background-50"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-100/20 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 善良的嫂子 · 内容导航站。本页仅作作品相关信息整理与展示。</p>
          <p className="flex items-center gap-2">
            <i className="ri-database-2-line" />
            目录内容以页面展示为准，持续整理更新中
          </p>
        </div>
      </div>
    </footer>
  );
}